import { FormBlockDef } from "src/components/FormWithBlocks";
import { ZObjectItem } from "src/types/ZObjectItem";
import { ZUid } from "src/types/zUid";
import { buildMnenoGroup } from "./buildMnemoGroup";
import { BuilderCtx } from "./BuilderCtx";

export const buildMainBlock = (
  object: ZObjectItem,
  ctx: BuilderCtx,
): FormBlockDef =>
  buildMnenoGroup(
    "mnemo-group",
    "",
    nonValued(object.attributes),
    nonValued(object.groups),
    { ...ctx, objectName: object.name },
  );

type Valued = {
  valueId?: ZUid | null;
};
const nonValued = <T extends Valued>(list: T[] | null | undefined): T[] =>
  (list ?? []).filter(({ valueId }) => !valueId);
